<template>
    <div>
        <div class="row mt-lg-5">
            <div class="col-lg-10 mx-auto my-4 my-lg-1">

                <div class="row mb-lg-5 p-lg-2 px-2">

                    <!-- Colonna sinistra - immagine -->
                    <div class="col-3 col-lg-2 px-0">
                        <img :src="imageFile" class="img-fluid" alt="Copertina del materiale">
                    </div>
                    <!-- /Colonna sinistra - immagine -->

                    <!-- Colonna destra - dati -->
                    <div class="col-9 col-lg-10">
                        <div class="row h-100">
                            <div class="col-12">
                                <div class="row align-items-start">
                                    <div class="col-12">
                                        <h5 class="mb-1">{{content.name }}</h5><!-- Titolo -->
                                        <span class="d-block"><em><small>{{ content.authors }}</small></em></span><!-- Autori -->
                                        <p class="mt-1"><strong>{{ content.goal }}</strong></p><!-- Descrizione -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Colonna destra - dati -->
                </div>

            </div>
        </div>

        <div class="row mt-lg-5">
            <div class="col-lg-10 mx-auto">
                <div class="table-responsive">
                    <table class="table table-hover align-middle">
                        <thead>
                            <tr>
                                <th scope="col">DATA</th>
                                <th scope="col">N. VIDEATE SUL TOTALE</th>
                                <th scope="col">TEMPO</th>
                                <th scope="col">% Di CORRETTEZZA</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rk) in rows" :key="rk">
                                <td class="py-3">{{  row.date | date-time }}</td><!-- Data -->
                                <td>{{ row.question_num }} / {{ row.question_total }}</td><!-- N. videate sul totale -->
                                <td>{{ Math.round(row.time / 1000) }} sec</td><!-- Tempo -->
                                <td>{{ Math.round(row.score * 100) }} %</td>
                                <td>    
                                    <a v-if="row.options" @click="onClickOpzioni(row)" class="cursor-pointer">
                                        opzioni
                                    </a>
                                </td>
                            </tr>      
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <MbModal ref="modal">
            <template #header>
                <h2>Opzioni</h2>
            </template>
            <template v-if="opzioni">
                <p class="mb-5">Opzioni impostate per l'esecuzione dell'esercizio.</p>
                
                <table class="table">
                    <tr v-for="(r, rk) in opzioni" :key="r">
                        <td>{{ rk }}</td>
                        <td>{{ r }}</td>
                    </tr>
                </table>
            </template>
        </MbModal>
    </div>
</template>
<script>

import MbModal from "@/components/ui/modal/MbModal"

export default {
    components: {
        MbModal
    },
    props: {
        content: Object,
        imageFile: String,
        rows: Array
    },
    data() {
        return {
            opzioni: null
        }
    },
    methods: {
        onClickOpzioni(row) {
            this.opzioni = JSON.parse( row.options )
            this.$refs.modal.toggle()
        }
    }
}
</script>